import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';

export class PhotoLOD extends DataModel {
  static readonly TYPE_ID: string = '787d3c97bbc1465897107e95072f6148';

  public readonly hasImageSize: boolean;
  public readonly aspectRatio: number;

  constructor(
    public readonly storagePath: string,
    public readonly downloadUrl: string,
    public readonly width: number,
    public readonly height: number,
  ) {
    super();
    this.hasImageSize = width > 0 && height > 0;
    this.aspectRatio = this.hasImageSize ? width / height : 0.0;
  }

  get $typeId() {
    return PhotoLOD.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PhotoLOD {
    return new PhotoLOD(
        MapUtils.getString(map, 'storagePath'),
        MapUtils.getString(map, 'downloadUrl'),
        MapUtils.getNumber(map, 'width'),
        MapUtils.getNumber(map, 'height'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'storagePath': this.storagePath,
      'downloadUrl': this.downloadUrl,
      'width': this.width,
      'height': this.height,
    };
  }

  clone(): this {
    return new PhotoLOD(
        this.storagePath,
        this.downloadUrl,
        this.width,
        this.height,
    ) as this;
  }

  isSame(other: PhotoLOD): boolean {
    if(other === this) {
      return true;
    }

    return other.height === this.height &&
        other.width === this.width &&
        other.storagePath === this.storagePath &&
        other.downloadUrl === this.downloadUrl;
  }
}

export class PhotoLODBuilder extends DataModelBuilder<PhotoLOD> {
  build(context: SerializationContext, map: SerializedData): PhotoLOD {
    return PhotoLOD.fromMap(context, map);
  }
}
